export const dateDifferenceInMinutes = (dt2, dt1) => {
    let diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    return Math.abs(Math.round(diff));
}


export const showGreeting = () => {
    const today = new Date()
    const curHr = today.getHours()

    if (curHr < 12) {
        return "Good Morning"
    } else if (curHr < 18) {
        return "Good Afternoon"
    } else {
        return "Good Evening"
    }
}

export function constructDate(day, month, year) {
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const dateString = `${months[month]} ${createDay(day.toString())} ${year}`;
    return dateString
}

function createDay(day) {
    if ((day[0] == 1 && day.length == 1) || (day.length == 2 && day[0] != 1 && day[1] == 1)) {
        return `${day}st`
    } else if ((day[0] == 2 && day.length == 1) || (day.length == 2 && day[0] != 1 && day[1] == 2)) {
        return `${day}nd`
    } else if ((day[0] == 3 && day.length == 1) || (day.length == 2 && day[0] != 1 && day[1] == 3)) {
        return `${day}rd`
    } else {
        return `${day}th`
    }
}

export function getDayOfTheWeek() {
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    let date = new Date()
    return {
        day: days[date.getDay()],
        date: date.getDate()
    }
}

export function generateYearsBetween(startYear, endYear) {
    const years = []
    for (let i = startYear; i >= endYear; i--) years.push(i)
    return years
}
